import { useTranslator } from '@bluebeam/react-i18n';
import ConnectedAccount from 'components/ConnectedAccount';
import React, { useState } from 'react';
import { ConnectedAccountList } from 'records/ConnectedAccount';
import { truncateString } from 'utils/general';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  accounts: ConnectedAccountList;
  onClick: (connectedAccountId: string) => void;
}

const SelectAccountStep: React.FC<Props> = ({
  appState,
  accounts,
  onClick,
}: Props) => {
  const { translate } = useTranslator(['requestDownloadModal', 'buttons']);
  const [currentSelected, setCurrentSelected] = useState(
    appState.integrationsConnectedAccountId
  );

  return (
    <>
      <div className="column px5 pt9 pb4 bb-2 ">
        <div className="color-black-2 font-size-7 medium">
          {translate(
            'requestDownloadModal:exportModal.selectAccountStep.title'
          )}
        </div>
        <div className="color-black-1 pt2 font-size-5 pb1 light">
          {translate(
            'requestDownloadModal:exportModal.selectAccountStep.content'
          )}
        </div>
      </div>
      <div className="px5 mt2">
        <div className="color-black-2 font-size-5 py3">
          {translate(
            'requestDownloadModal:exportModal.selectAccountStep.connectedAccounts',
            { accountsCount: accounts.size }
          )}
        </div>
        <div
          className="b-3 bgd-light-grey-2 column pb3 oxa "
          style={{ height: 270 }}
        >
          {accounts &&
            accounts.map((connectedAccount, index) => {
              return (
                <ConnectedAccount
                  key={connectedAccount.id}
                  account={connectedAccount}
                  index={index}
                  label={truncateString(connectedAccount.label, 23)}
                  onClick={() => {
                    onClick(connectedAccount.id);
                    setCurrentSelected(connectedAccount.id);
                  }}
                  classes={
                    currentSelected === connectedAccount.id
                      ? 'bgd-primary-blue-tint-90'
                      : ''
                  }
                />
              );
            })}
        </div>
      </div>
    </>
  );
};

export default withAppStore<Props>(SelectAccountStep);
